import { render, staticRenderFns } from "./ModalDeleteSnippet.vue?vue&type=template&id=4cdfa1ce&scoped=true"
import script from "./ModalDeleteSnippet.vue?vue&type=script&lang=js"
export * from "./ModalDeleteSnippet.vue?vue&type=script&lang=js"
import style0 from "./ModalDeleteSnippet.vue?vue&type=style&index=0&id=4cdfa1ce&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdfa1ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cdfa1ce')) {
      api.createRecord('4cdfa1ce', component.options)
    } else {
      api.reload('4cdfa1ce', component.options)
    }
    module.hot.accept("./ModalDeleteSnippet.vue?vue&type=template&id=4cdfa1ce&scoped=true", function () {
      api.rerender('4cdfa1ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/ModalDeleteSnippet.vue"
export default component.exports